import sortBy from 'lodash/orderBy'
import isEmpty from 'lodash/isEmpty'
import { region } from '@/utils/utils'
import { gameUidKey, gameZoneidKey } from '@/utils/storage'
import { abTestFilterate } from '@page_detail/adSeckillConfig'

export default {
  filterCurrencySkus: (state, _, rootState, rootGetters) => {
    const _selectGokSkuids = state.selectGokSkuids
    const _publicSkuList = state.publicSkuList
    const _filterPublicSkuList = {}

    if (isEmpty(_publicSkuList)) return []
    // pns、3d
    if (rootGetters.isParallelRequestsGame) {
      for (let i = 0; i < _publicSkuList.length; i++) {
        let _item = _publicSkuList[i]
        _filterPublicSkuList[_item.catalog] = _item.products
      }
      return _filterPublicSkuList
    }

    if (_selectGokSkuids.length === 0 && Array.isArray(_publicSkuList)) {
      return abTestFilterate(rootState, rootGetters, _publicSkuList)
    }

    // 考虑到publicSkuList可能是对象的形式【GOK】

    for (let k in _publicSkuList) {
      let c = _publicSkuList[k]
      _filterPublicSkuList[k] = []

      for (let i = 0; i < c.length; i++) {
        if (_selectGokSkuids.includes(c[i].skuId)) {
          _filterPublicSkuList[k].push(c[i])
        }
      }
    }
    return _filterPublicSkuList
  },
  cacheUidKey: (state, _, rootState) => {
    return `${gameUidKey}-${region()}-${rootState.gameName}`
  },
  cacheZidKey: (state, _, rootState) => {
    return `${gameZoneidKey}-${region()}-${rootState.gameName}`
  },
  gameCouponList(state) {
    // 当前游戏内所有可用的优惠券列表
    const { couponList = [], otherCouponList = [] } = state.coupons || {}
    return [...couponList, ...otherCouponList]
  },

  // warn: 'turbo-vpn', 'vpn-proxy-master'
  // vpn的两个游戏前端排序
  vpnGamesSortList({ publicSkuList }, _, rootState, rootGetters) {
    if (!rootGetters.isVpnGames) return []

    try {
      if (publicSkuList && publicSkuList.length) {
        return sortBy(publicSkuList, [
          (item) => item.skuName.split('-')[1],
          (item) => 100 - Number(item.skuName.split('-')[0].split(' ')[0]),
        ])
      }
      return []
    } catch (error) {
      return []
    }
  },
  // 是否展示 APP的好评弹层
  // 会员等级 >=1 证明消费国一次、@诗媛
  isRenderAppGoodLayer(state, _, rootState, rootGetters) {
    return (
      rootState.region == 'ru' &&
      rootGetters.isLogin &&
      rootState.members.userInfo.levelCode >= 1 &&
      rootState.isApp
    )
  },

  // code模式是否存在官网地址
  isCodeRedeemUrl(state) {
    return state.detailBasicConfig.gameShowDetail?.redeemUrl || ''
  },
}
